"use strict";

var _interopRequireDefault = require("/var/lib/jenkins/workspace/pay-center-front-master/node_modules/@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es6.function.name");

require("core-js/modules/es7.symbol.async-iterator");

require("core-js/modules/es6.symbol");

require("core-js/modules/web.dom.iterable");

var _objectSpread2 = _interopRequireDefault(require("/var/lib/jenkins/workspace/pay-center-front-master/node_modules/@babel/runtime-corejs2/helpers/objectSpread2"));

require("core-js/modules/es6.regexp.search");

var _moment = _interopRequireDefault(require("moment"));

var _httpUtils = _interopRequireDefault(require("@/utils/http-utils"));

var _PermissionPage = _interopRequireDefault(require("@/components/Page/PermissionPage"));

var _PermissionSimplePage = _interopRequireDefault(require("@/components/Page/PermissionSimplePage"));

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var treeProps = {
  children: "children",
  label: "name"
};
var _default = {
  name: "dept:view",
  permission: "roleManagement",
  extends: _PermissionPage.default,
  components: {
    PermissionSimplePage: _PermissionSimplePage.default
  },
  data: function data() {
    return {
      viewOnly: false,
      paginationOptions: {
        page: 1,
        limit: 10
      },
      showDialog: false,
      tree: [],
      tableData: [],
      totalData: 0,
      search: "",
      formData: {},
      formTitle: "",
      formButton: "",
      rules: {
        deptName: [{
          required: true,
          message: this.$t("system.dept.deptName") + this.$t("SMS.canNotBeEmpty"),
          trigger: "blur"
        }]
      },
      treeProps: treeProps,
      toBeDelete: null,
      loading: true,
      currentTree: []
    };
  },
  created: function created() {
    this.fetchData();
  },
  // watch: {
  //   search(val) {
  //     this.$refs.tree.filter(val);
  //   }
  // },
  methods: {
    fetchData: function fetchData() {
      var _this2 = this;

      var _this = this;

      _this.loading = true;

      _httpUtils.default.post("dept", "tree", null, {
        deptName: _this.search
      }).then(function (res) {
        if (res.code == 200) {
          _this.tree = res.data;

          _this.$nextTick(function () {
            return _this.handleCheck();
          });
        } else {
          _this.$notify({
            title: _this2.$t("common.error"),
            message: _this2.$t("common.fetchError"),
            type: "error"
          });
        }

        _this.loading = false;
      }).catch(function (err) {
        _this.$notify({
          title: _this2.$t("common.error"),
          message: _this2.$t("common.fetchError") + ',' + err.message,
          type: "error"
        });

        _this.loading = false;
      });
    },
    addData: function addData(data) {
      var _this3 = this;

      var _this = this;

      _httpUtils.default.post("dept", "add", null, data).then(function (res) {
        if (res.code == 200) {
          _this.fetchData();

          _this.closeDialog();

          _this.$notify({
            title: _this.$t("common.success"),
            message: _this.$t("system.dept.formSubmitAddSuccessText"),
            type: "success"
          });
        } else {
          _this.$notify({
            title: _this.$t("common.error"),
            message: res.message,
            type: "error"
          });
        }
      }).catch(function (err) {
        _this.$notify({
          title: _this3.$t("common.error"),
          message: _this3.$t("common.fetchError") + ',' + err.message,
          type: "error"
        });
      });
    },
    updateData: function updateData(data) {
      var _this4 = this;

      var _this = this;

      _httpUtils.default.post("dept", "update", null, data).then(function (res) {
        if (res.code == 200) {
          _this.fetchData();

          _this.closeDialog();

          _this.$notify({
            title: _this.$t("common.success"),
            message: _this.$t("system.dept.formSubmitEditSuccessText"),
            type: "success"
          });
        } else {
          _this.$notify({
            title: _this.$t("common.error"),
            message: res.message,
            type: "error"
          });
        }
      }).catch(function (err) {
        _this.$notify({
          title: _this4.$t("common.error"),
          message: _this4.$t("common.fetchError") + ',' + err.message,
          type: "error"
        });
      });
    },
    deleteData: function deleteData(data) {
      var _this5 = this;

      var _this = this;

      _httpUtils.default.post("dept", "delete", null, data).then(function (res) {
        if (res.code == 200) {
          _this.fetchData();

          _this.$notify({
            title: _this.$t("common.success"),
            message: _this.$t("system.dept.dropdownDeleteSuccessText"),
            type: "success"
          });

          _this.$nextTick(function () {
            return _this.handleCheck();
          });
        } else {
          _this.$notify({
            title: _this.$t("common.error"),
            message: res.message,
            type: "error"
          });
        }
      }).catch(function (err) {
        _this.$notify({
          title: _this5.$t("common.error"),
          message: _this5.$t("common.fetchError") + ',' + err.message,
          type: "error"
        });
      });
    },
    handleDialog: function handleDialog(cmd) {
      var _this6 = this;

      this.initForm(cmd);
      var checkedNodes = this.$refs.tree.getCheckedNodes();

      if (cmd == "add") {
        if (checkedNodes[0]) {
          this.formData.parentId = checkedNodes[0].id;
        } else {
          this.formData.parentId = "";
        }
      }

      if (cmd == "edit") {
        this.fillForm(checkedNodes[0]);
      }

      this.$nextTick(function () {
        _this6.showDialog = true;
      });
    },
    handlePagination: function handlePagination(newOptions) {
      var _this7 = this;

      this.paginationOptions = newOptions;
      this.$nextTick(function () {
        return _this7.fetchData();
      });
    },
    handleSubmit: function handleSubmit() {
      var _this8 = this;

      this.$refs["dataForm"].validate(function (valid) {
        if (valid) {
          var dummy = (0, _objectSpread2.default)({}, _this8.formData);

          _this8.$nextTick(function () {
            if (dummy.deptId) {
              _this8.updateData(dummy);
            } else {
              _this8.addData(dummy);
            }
          });
        }
      });
    },
    handleSelectionChange: function handleSelectionChange(val) {
      this.toBeDelete = val;
    },
    handleMultipleDelete: function handleMultipleDelete() {
      var _this9 = this;

      var checkedNodes = this.$refs.tree.getCheckedNodes();

      if (!checkedNodes.length) {
        this.$notify({
          title: _this.$t("common.error"),
          message: _this.$t("system.dept.dropdownDeleteWarnText"),
          type: "error"
        });
        return;
      }

      var menuIds = [];
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = checkedNodes[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var node = _step.value;
          menuIds.push(node.id);
        } // check if has child

      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return != null) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      this.$confirm(this.$t("system.dept.dropdownDeleteInfoText"), this.$t("common.warning"), {
        confirmButtonText: this.$t("common.delete"),
        cancelButtonText: this.$t("common.cancel"),
        type: "warning"
      }).then(function () {
        return _this9.deleteData(menuIds);
      }).catch(function () {
        return null;
      });
    },
    handleCheck: function handleCheck() {
      this.currentTree = this.$refs.tree.getCheckedNodes();
    },
    initForm: function initForm(cmd) {
      if (cmd == "add") {
        this.formTitle = this.$t("system.dept.formHeader");
        this.formButton = this.$t("common.add");
      } else if (cmd == "edit") {
        this.formTitle = this.$t("system.dept.eleTreeHeaderText");
        this.formButton = this.$t("common.edit");
      }

      this.formData = {};
      this.viewOnly = false;
    },
    fillForm: function fillForm(node) {
      this.formData = {
        deptId: node.id,
        deptName: node.name,
        orderNum: node.data.orderNum,
        parentId: node.parentId
      };
    },
    closeDialog: function closeDialog() {
      var _this10 = this;

      this.showDialog = false;
      this.formData = {};
      this.$nextTick(function () {
        return _this10.$refs.dataForm.clearValidate();
      });
    },
    dateFormat: function dateFormat(date) {
      if (date == undefined) {
        return "";
      }

      return (0, _moment.default)(date).format("YYYY-MM-DD HH:mm:ss");
    },
    filterNode: function filterNode(value, data) {
      if (!value) return true;
      return data.name.indexOf(value) !== -1;
    }
  }
};
exports.default = _default;